import { render, staticRenderFns } from "./CitasCalendario.vue?vue&type=template&id=462f1489&"
import script from "./CitasCalendario.vue?vue&type=script&lang=js&"
export * from "./CitasCalendario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports